import Second1 from 'assets/Home/second1.avif'
import Second2 from 'assets/Home/second2.avif'
import Second3 from 'assets/Home/second3.avif'

import Second1Mo from 'assets/Home/second1Mo.avif'
import Second2Mo from 'assets/Home/second2Mo.avif'
import Second3Mo from 'assets/Home/second3Mo.avif'

interface TeamData {
    id: number
    title: string[],
    content: string[],
    img: string,
    imgMo: string,
}

export const secondData: TeamData[] = [
    {
        id: 0,
        title: ['BUSINESS', 'INSIGHT'],
        content: [
            'IT 비즈니스 인사이트는 고객의 산업 분야와 시장 흐름을 이해하고,',
            '데이터 기반으로 전략을 세우는 것이 필요합니다. TINSLAB는 기술 솔루션을',
            '넘어 고객의 비즈니스 성공을 돕기 위한 강력한 파트너로서 함께 합니다.'
        ],
        img: Second1,
        imgMo: Second1Mo,
    },
    {
        id: 1,
        title: ['SERVICE', 'DEVELOP'],
        content: [
            'TINS LAB는 최신 기술을 사용하여, 고객의 비즈니스 요구에 맞는 맞춤형',
            '솔루션을 개발합니다.Agile 및 DevOps 방법론을 채택하여 체계적인',
            '프로세스를 통해, 보다 빠르고 효과적인 서비스를 제공합니다.',
        ],
        img: Second2,
        imgMo: Second2Mo,
    },
    {
        id: 2,
        title: ['UX', 'DESIGN'],
        content: [
            '단순히 예쁘기만 한 디자인이 아닌, 사용성을 최우선으로 고려한',
            '디자인을 제공합니다. 시각적 아름다움과 기능적 효율성을 동시에 추구하여,',
            '사용자가 서비스 사용 중에 불편함없이 목표를 달성할 수 있도록 돕습니다.'
        ],
        img: Second3,
        imgMo: Second3Mo,
    },
]